/**
 * Checks if a string or number contains any digits.
 * @param {string | number} val - The value to check for digits
 * @returns {boolean} True if the value contains at least one digit, false otherwise
 * @example
 * containsNumbers('abc123') // returns true
 * containsNumbers('abc') // returns false
 * containsNumbers(123) // returns true
 */
export const containsNumbers = (val: string | number): boolean =>
    /[0-9]/.test(String(val));
